import type { RuleFunction } from '@composables/useValidation';

export interface InputProps<T> {
    id?: string;
    label?: string;
    modelValue?: T;
    disabled?: boolean;
    required?: boolean;
    errorMessage?: string;
    rules?: RuleFunction<T>[];
    name?: string;
}

export type InputEmits<T> = {
    (e: 'update:modelValue', value: T): void;
};

export interface UseInput {
    id: ComputedRef<Readonly<string>>;
}

// TODO: this doesnt work when component has more props than those returned by that function (used via destructuring)
// TODO: how to add typing here?
export const getDefaultValues = () => {
    return {
        label: '',
        id: '',
        errorMessage: '',
        disabled: false,
        required: false,
        rules: () => [],
        name: '',
    };
};

export const useInput = (
    inputType: string,
    propId?: MaybeRefOrGetter<string | undefined>
): UseInput => {
    const id = useId();
    const computedId = computed(() => {
        return toValue(propId) || `${inputType}-${id}`;
    });

    return {
        id: computedId,
    };
};
